export default __webpack_public_path__ + "static/media/Doubles_2.cd71ec57.jpg";